import { useEffect } from "react";

const WARNING =
  "You are offline. If you reload this page, you may encounter a blank page until you are back online. Do you want to continue?";

/**
 * Blocks browser back-button navigation and reload when offline.
 *
 * @param {boolean} isOnline - current network status
 */
function useOfflineGuard(isOnline) {
  useEffect(() => {
    if (isOnline) return;

    // Push a dummy state so we "absorb" the back press first.
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      const confirmed = window.confirm(WARNING);
      if (confirmed) {
        window.history.back();
      } else {
        // Re-push so the next back press is also caught
        window.history.pushState(null, "", window.location.href);
      }
    };

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = WARNING;
      return WARNING;
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isOnline]);
}

export default useOfflineGuard;

